<template>
    <placement>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :searchable="true" :fields="fields" :items="companyjobs" :action="{'text':'add Job','url':route('placement.job.create')}" :searchlink="route('placement.job.search')" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Job')" :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Job')">
                <template #company="data">
                    {{data.item.company.name}}
                </template>
                <template #action="data">
                    <button-link v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Job Students')" :href="route('placement.job.students',data.item.id)" class="mr-4">Students</button-link>
                    <button-link v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Job')" :href="route('placement.job.edit',data.item.id)" >Edit</button-link>
                </template>
            </breeze-table>
        </div>
    </placement>
</template>

<script>
    import Placement from '@/Pages/Placement/Placement'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'

    export default {
        components: {
            Placement,
            BreezeTable,
            ButtonLink
        },
        props:['companyjobs'],
        data(){
            return{
                fields:[{'key':'company','label':'Company'},{'key':'job_title','label':'JOb Title'},{'key':'monthly_salary','label':'Monthly Salary'},{'key':'no_of_openings','label':'No of Openings'},{'key':'job_location','label':'Job Locations'},{'key':'valid_till','label':'Valid Till'},{'key':'action','label':'Action'}]
            }
        },
    }
</script>
